<template>
  <div class="bg-background flex min-h-screen items-center justify-center">
    <div class="max-w-md p-8 text-center">
      <font-awesome-icon :icon="['fal', 'circle-xmark']" class="text-error-500 mb-4 text-6xl" />
      <h1 class="text-text mb-4 text-3xl font-semibold">{{ t('auth.notAllowed.title') }}</h1>
      <p class="text-text-secondary mb-8">{{ t('auth.notAllowed.message') }}</p>

      <div class="flex justify-center gap-3">
        <InfuseButton color="secondary" @click="router.replace('/')">
          {{ t('auth.notAllowed.backToHome') }}
        </InfuseButton>
        <InfuseButton @click="logout">
          <font-awesome-icon :icon="['far', 'arrow-right-from-bracket']" class="mr-2" />
          {{ t('auth.notAllowed.logout') }}
        </InfuseButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAuthenticator } from '@infuse/auth/services';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { InfuseButton } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const authenticator = useAuthenticator();
const currentUserStore = useCurrentUserStore();

async function logout() {
  await authenticator.logout();
  currentUserStore.reset();
  await router.push({ name: 'auth-login' });
}
</script>
